import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';

///////////////////////////////////////////////////////////////////////////////
// dialog-share - component for the share/mail to colleague dialog           //
///////////////////////////////////////////////////////////////////////////////

export interface AditoolsDialogShareSignature {
  Element: HTMLDialogElement;
  Args: {
    title: string;
    close: () => void;
    share: (name: string, sender: string, emails: string) => void;
    dialogEnabled: boolean;
    closeButtonText?: string;
    saveButtonText?: string;
    dialogClass?: string;
    submit?: () => void; // Obsolete
  };
}
type AditoolsDialogShareArgs = AditoolsDialogShareSignature['Args'];

export default class AditoolsDialogShare extends Component<AditoolsDialogShareSignature> {
  @tracked designName = '';
  @tracked designSender = '';
  @tracked designEmailList: string[] = [];

  @tracked isDesignNameValid = false;
  @tracked isDesignSenderValid = false;
  @tracked emailListIsValid = false;
  @tracked emailErrorMessage = '';

  constructor(owner: unknown, args: AditoolsDialogShareArgs) {
    super(owner, args);
    this.initializeValues();
  }

  initializeValues() {
    this.designName = '';
    this.designSender = '';
    this.designEmailList = [''];
    this.isDesignNameValid = true;
    this.isDesignSenderValid = true;
    this.emailListIsValid = true;
    this.emailErrorMessage = '';
  }

  // This function is called when the user clicks on the save button. This validates the Design Name,Design Sender Name and Email Receipient Fields
  validateShareFields() {
    const designName = this.designName ? this.designName.trim() : '';
    const designSender = this.designSender ? this.designSender.trim() : '';

    this.isDesignNameValid = designName.length > 0;
    this.isDesignSenderValid = designSender.length > 0;
    if (
      this.designEmailList === null ||
      (this.designEmailList && this.designEmailList.length === 0) ||
      (this.designEmailList && this.designEmailList.length === 1 && this.designEmailList[0] === '')
    ) {
      this.emailListIsValid = false;
      this.emailErrorMessage = 'ember-aditools-page.dialogs.share.share-email-empty-error';
    }
    return this.isDesignNameValid && this.isDesignSenderValid && this.emailListIsValid;
  }

  @action validateDesignName(event: Event) {
    const target = event.target as HTMLInputElement;
    this.designName = target.value.trim();
    this.isDesignNameValid = this.designName.length > 0;
  }

  @action validateSenderName(event: Event) {
    const target = event.target as HTMLInputElement;
    this.designSender = target.value.trim();
    this.isDesignSenderValid = this.designSender.length > 0;
  }

  @action onChange(emails: string[], hasInvalids: boolean) {
    this.designEmailList = emails;
    this.emailErrorMessage =
      emails.length > 0 && hasInvalids
        ? 'ember-aditools-page.dialogs.share.share-email-format-error'
        : emails.length === 0
        ? 'ember-aditools-page.dialogs.share.share-email-empty-error'
        : emails.length === 1 && emails[0] === ''
        ? 'ember-aditools-page.dialogs.share.share-email-empty-error'
        : '';
    this.emailListIsValid = this.emailErrorMessage === '' ? true : false;
  }

  // Do the work then cause the dialog to close
  @action shareDesign(closeDialog: () => void) {
    if (this.validateShareFields()) {
      if (this.args.share) {
        const distinctEmails = [...new Set(this.designEmailList)];
        const emails = distinctEmails
          .filter(function (e) {
            return e;
          })
          .join(';');
        this.args.share(this.designName, this.designSender, emails);
      }
      closeDialog();
    }
  }

  // The following is called after the dialog closes
  @action clearAndClose() {
    this.initializeValues();
    this.args.close();
  }
}
